import React from 'react';
import { useNavigate } from 'react-router-dom';

const Location = () => {
  const navigate = useNavigate();
  return (
    <section id="location" className="relative py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-black px-8 py-3 text-sm tracking-widest hover:bg-gray-200 transition-colors"
          >
            ENQUIRE ABOUT TATTOO
          </button>
          <button
            data-testid="home-buy-vouchers-btn"
            onClick={() => navigate('/shop')}
            className="border border-white text-white px-8 py-3 text-sm tracking-widest hover:bg-white hover:text-black transition-colors"
          >
            BUY VOUCHERS
          </button>
        </div>
      </div>
    </section>
  );
};

export default Location;